const middleware = {}

middleware['cascaderData'] = require('../middleware/cascaderData.js')
middleware['cascaderData'] = middleware['cascaderData'].default || middleware['cascaderData']

middleware['init'] = require('../middleware/init.js')
middleware['init'] = middleware['init'].default || middleware['init']

export default middleware
